// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"6d4fff5c","228":"6d4fff5c","277":"6d4fff5c","454":"6d4fff5c","673":"6d4fff5c","677":"6d4fff5c","745":"6d4fff5c","746":"6d4fff5c","839":"6c52375c"}[chunkId] + ".chunk.css";
};